import { Link } from "react-router-dom"; // import Link for navigation
import "./AllBlog.css";
import { NavBar, Footer } from "../../Components/ExportComponents";

const blogsData = [
  {
    id: 1,
    title: "The Power of Visual Identity in Branding",
    author: "Ashok Kafle",
    role: "Marketing Head",
    img: "https://randomuser.me/api/portraits/men/45.jpg",
    category: "Design",
    date: "2 days ago",
  },
  {
    id: 2,
    title: "Why Graphic Design is the New Language of Business",
    author: "Ashok Kafle",
    role: "Marketing Head",
    img: "https://randomuser.me/api/portraits/men/45.jpg",
    category: "Marketing",
    date: "5 days ago",
  },
  {
    id: 3,
    title: "UI/UX Trends That Are Shaping 2025",
    author: "Ashok Kafle",
    role: "Marketing Head",
    img: "https://randomuser.me/api/portraits/men/45.jpg",
    category: "UI/UX",
    date: "1 week ago",
  },
  {
    id: 4,
    title: "How Typography Impacts User Experience",
    author: "Ashok Kafle",
    role: "Marketing Head",
    img: "https://randomuser.me/api/portraits/men/45.jpg",
    category: "Design",
    date: "8 days ago",
  },
  {
    id: 5,
    title: "Designing for Emotion: Color Psychology in Web",
    author: "Ashok Kafle",
    role: "Marketing Head",
    img: "https://randomuser.me/api/portraits/men/45.jpg",
    category: "Marketing",
    date: "10 days ago",
  },
  {
    id: 6,
    title: "Responsive Design for Nepali Audiences",
    author: "Ashok Kafle",
    role: "Marketing Head",
    img: "https://randomuser.me/api/portraits/men/45.jpg",
    category: "Web Development",
    date: "12 days ago",
  },
  {
    id: 7,
    title: "Crafting Festival Visuals That Resonate",
    author: "Ashok Kafle",
    role: "Marketing Head",
    img: "https://randomuser.me/api/portraits/men/45.jpg",
    category: "Culture",
    date: "2 weeks ago",
  },
  {
    id: 8,
    title: "From Prototypes to Impact: Design That Converts",
    author: "Ashok Kafle",
    role: "Marketing Head",
    img: "https://randomuser.me/api/portraits/men/45.jpg",
    category: "UI/UX",
    date: "3 weeks ago",
  },
  {
    id: 9,
    title: "Digital Storytelling for Local Brands",
    author: "Ashok Kafle",
    role: "Marketing Head",
    img: "https://randomuser.me/api/portraits/men/45.jpg",
    category: "Branding",
    date: "1 month ago",
  },
  {
    id: 10,
    title: "Design Systems: Consistency in Modern Apps",
    author: "Ashok Kafle",
    role: "Marketing Head",
    img: "https://randomuser.me/api/portraits/men/45.jpg",
    category: "UI/UX",
    date: "1 month ago",
  },
];


const AllBlog = () => {
  return (
    <>
      <NavBar />
      <div className="showAllBlogs">
        <div className="blogTitle">Blogs</div>

        <div className="blogsList">
          {blogsData.map((blog) => (
            <Link
              to={`/blog/${blog.id}`} // link to blog page
              key={blog.id}
              className="blogCardLink"
            >
              <div className="blogCard">
                <div className="blogPreviewRow">
                  <div className="blogAuthor">
                    <img src={blog.img} alt={blog.author} />
                    <h4>{blog.author}</h4>
                  </div>
                  <p className="blogDate">{blog.date}</p>
                  <span className="blogCategory">{blog.category}</span>
                  <h2 className="blogTitleText">{blog.title}</h2>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AllBlog;
